import React from 'react'

const Home = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <h1 style={{textAlign: "center"}}>Welcome to Higher Mind!</h1>
    </div>
  )
}

export default Home